var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5Z",
    fill: "#EF0606"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4434 5.72L14.1554 14.414H12.0314L11.7254 5.72H14.4434ZM13.1474 18.626C12.6914 18.626 12.3134 18.488 12.0134 18.212C11.7254 17.924 11.5814 17.57 11.5814 17.15C11.5814 16.73 11.7254 16.382 12.0134 16.106C12.3134 15.818 12.6914 15.674 13.1474 15.674C13.5914 15.674 13.9574 15.818 14.2454 16.106C14.5334 16.382 14.6774 16.73 14.6774 17.15C14.6774 17.57 14.5334 17.924 14.2454 18.212C13.9574 18.488 13.5914 18.626 13.1474 18.626Z",
    fill: "#FAFF10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.34a03ac8dd1d8d26472b16802728461b.svg";
export { ForwardRef as ReactComponent };